import React, { useState } from 'react';
import { api } from '../../utils/api';
import { TextField, Button, Box, Typography, Alert, FormControlLabel, Checkbox } from '@mui/material';

export default function BarOnboarding() {
    const [barData, setBarData] = useState({
        barName: '',
        phoneNumber: '',
        email: '',
        signupEnabled: true,
        includeMembershipQuestion: false,
        customStyles: {
            primaryColor: '#000000',
            logo: ''
        },
        messagingProfileId: ''
    });
    const [success, setSuccess] = useState(false);
    const [signupUrl, setSignupUrl] = useState('');
    const [error, setError] = useState('');

    // Function to convert bar name to URL-friendly slug
    const createSlug = (name) => {
        return name
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '')
            .trim();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess(false);
        
        try {
            // Only send required fields to the backend
            const submissionData = {
                barName: barData.barName,
                email: barData.email,
                phoneNumber: barData.phoneNumber,
                messagingProfileId: barData.messagingProfileId,
                includeMembershipQuestion: barData.includeMembershipQuestion
            };

            // Remove any empty fields
            Object.keys(submissionData).forEach(key => {
                if (submissionData[key] === '' || submissionData[key] === undefined) {
                    delete submissionData[key];
                }
            });

            const response = await api.post('/api/admin/bars', submissionData);
            const newSignupUrl = `${window.location.origin}/join/${response.slug}`;
            setSignupUrl(newSignupUrl);
            setSuccess(true);
            
            // Clear form
            setBarData({
                barName: '',
                phoneNumber: '',
                email: '',
                messagingProfileId: '',
                signupEnabled: true,
                includeMembershipQuestion: false,
                customStyles: {
                    primaryColor: '#000000',
                    logo: ''
                }
            });
        } catch (error) {
            console.error('Error creating bar:', error);
            setError(error.message || 'Failed to create bar account');
        }
    };

    return (
        <Box sx={{ mt: 4, pb: 8 }}>
            <form onSubmit={handleSubmit}>
                <TextField
                    fullWidth
                    label="Bar Name"
                    value={barData.barName}
                    onChange={(e) => setBarData({...barData, barName: e.target.value})}
                    margin="normal"
                    required
                    helperText="This will be used in your signup URL"
                />
                <TextField
                    fullWidth
                    label="Email"
                    type="email"
                    value={barData.email}
                    onChange={(e) => setBarData({...barData, email: e.target.value})}
                    margin="normal"
                    required
                />
                <TextField
                    fullWidth
                    label="Phone Number"
                    value={barData.phoneNumber}
                    onChange={(e) => setBarData({...barData, phoneNumber: e.target.value})}
                    margin="normal"
                    required
                    helperText="Format: +1XXXXXXXXXX"
                />
                <TextField
                    fullWidth
                    label="Messaging Profile ID"
                    value={barData.messagingProfileId || ''}
                    onChange={(e) => setBarData({...barData, messagingProfileId: e.target.value})}
                    margin="normal"
                    required
                    helperText="Telnyx Messaging Profile ID"
                />
                
                <Box sx={{ mt: 3, mb: 3 }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={barData.includeMembershipQuestion}
                                onChange={(e) => setBarData({
                                    ...barData, 
                                    includeMembershipQuestion: e.target.checked
                                })}
                            />
                        }
                        label="Include membership status question in signup form"
                    />
                </Box>
                
                {error && (
                    <Alert severity="error" sx={{ mt: 2, mb: 2 }}>
                        {error}
                    </Alert>
                )}

                <Button 
                    type="submit" 
                    variant="contained" 
                    size="large"
                    sx={{ mt: 2 }}
                >
                    Create Bar Account
                </Button>
            </form>

            {success && (
                <Alert severity="success" sx={{ mt: 2 }}>
                    <Typography>Bar successfully created!</Typography>
                    <Typography>Signup URL: <strong>{signupUrl}</strong></Typography>
                </Alert>
            )}
        </Box>
    );
} 